import React from "react";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Layout from "components/Layout";
import Modal from "components/Modal";
import { showModal, hideModal } from "actions/modalActions";
import { NavLink } from "react-router-dom";
import {
	FiUser,
	FiUsers,
	FiRefreshCcw,
	FiSliders,
	FiCreditCard,
	FiSettings,
	FiChevronRight,
	FiLink,
} from "react-icons/fi";
import {
	isAdmin,
	isSupervisor,
	hasSubscriptionFeature,
	isSupervisorWithEditShifts,
	isSupervisorWithEditPlanning,
} from "utils/utils";
import { isHaddockEnvironment } from "utils/documentUtils";
import { openGeneralConfigDrawer } from "components/GeneralConfig/openGeneralConfigDrawer";

class Settings extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
	}

	closeModal() {
		this.props.hideModal();
	}

	openGeneralConfig = () => {
		openGeneralConfigDrawer(this.props.showModal);
	};

	render() {
		const { user, t } = this.props;
		const groups_supervised = user.groups_supervised;
		const supervisorCanEditShifts = isSupervisorWithEditShifts(groups_supervised);
		const supervisorCanEditPlanning =
			isSupervisorWithEditPlanning(groups_supervised);
		const isSupervisorWithEditStaffing =
			isSupervisor() &&
			groups_supervised.length > 0 &&
			groups_supervised.some((gs) => gs.edit_staffing_levels);
		const isSupervisorWithEditGroups =
			isSupervisor() &&
			groups_supervised.length > 0 &&
			groups_supervised.some((gs) => gs.edit_groups);

		const showShiftsSection =
			isAdmin() || supervisorCanEditShifts || supervisorCanEditPlanning;
		const showShiftsLink = isAdmin() || supervisorCanEditShifts;
		const showShiftPatternsLink = isAdmin() || supervisorCanEditPlanning;
		const showStaffing =
			isAdmin() || isSupervisorWithEditStaffing || isSupervisorWithEditGroups;

		const hasPowersWithExpensesSubscription =
			(isAdmin() || isSupervisor()) && hasSubscriptionFeature("EXPENSES");

		const integrationAppName = isHaddockEnvironment() ? "haddock" : "Plain";

		return (
			<>
				<Layout configSidebar={true} className="page-settings">
					<div className="heading">
						<h1 className="title">{t("settings.title")}</h1>
					</div>

					<div className="settings-content">
						{isAdmin() && (
							<button
								type="button"
								className="settings-general-banner"
								onClick={this.openGeneralConfig}
							>
								<span className="settings-general-banner__icon">
									<FiSettings />
								</span>
								<span className="settings-general-banner__text">
									<span className="settings-general-banner__title">
										{t("settings.general.title")}
									</span>
									<span className="settings-general-banner__description">
										{t("settings.general.description")}
									</span>
								</span>
								<FiChevronRight className="settings-general-banner__chevron" />
							</button>
						)}

						<Row>
						{isAdmin() && (
							<Col sm={6}>
								<article className="card card-settings">
									<div className="card-header">
										<div className="card-icon-wrapper">
											<FiUser className="card-icon" />
										</div>
										<h3 className="card-title">{t("settings.employees.title")}</h3>
									</div>
									<p>{t("settings.employees.description")}</p>

									<ul className="list-pages">
										<li>
											<NavLink to="/contracts" exact activeClassName="active">
												<span className="option-text">{t("settings.employees.contracts")}</span>
											</NavLink>
										</li>
										<li>
											<NavLink
												to="/employee-functions"
												exact
												activeClassName="active"
											>
												<span className="option-text">{t("settings.employees.functions")}</span>
											</NavLink>
										</li>
										<li>
											<NavLink
												to="/employee-ubications"
												exact
												activeClassName="active"
											>
												<span className="option-text">{t("settings.employees.locations")}</span>
											</NavLink>
										</li>
										<li>
											<NavLink
												to="/custom-fields"
												exact
												activeClassName="active"
											>
												<span className="option-text">
													{t("settings.employees.customFields")}
												</span>
											</NavLink>
										</li>
									</ul>
								</article>
							</Col>
						)}
						{showShiftsSection && (
							<Col sm={6}>
								<article className="card card-settings">
									<div className="card-header">
										<div className="card-icon-wrapper">
											<FiRefreshCcw className="card-icon" />
										</div>
										<h3 className="card-title">{t("settings.shifts.title")}</h3>
									</div>
									<p>{t("settings.shifts.description")}</p>
									<ul className="list-pages">
										{showShiftsLink && (
											<li>
												<NavLink to="/shifts" activeClassName="active">
													<span className="option-text">{t("settings.shifts.shifts")}</span>
												</NavLink>
											</li>
										)}
										{showShiftPatternsLink && (
											<li>
												<NavLink
													to="/shift-patterns"
													exact
													activeClassName="active"
												>
													<span className="option-text">{t("settings.shifts.shiftPatterns")}</span>
												</NavLink>
											</li>
										)}
										{isAdmin() && (
											<>
												<li>
													<NavLink
														to="/time-types"
														exact
														activeClassName="active"
													>
														<span className="option-text">{t("settings.shifts.timeTypes")}</span>
													</NavLink>
												</li>
												<li>
													<NavLink to="/calendars" activeClassName="active">
														<span className="option-text">{t("settings.shifts.calendars")}</span>
													</NavLink>
												</li>
												{user?.company?.partner === true && (
													<li>
														<NavLink to="/calendars-system" exact activeClassName="active">
															<span className="option-text">{t("calendars.system.menu")}</span>
														</NavLink>
													</li>
												)}
												<li>
													<NavLink
														to="/day-types"
														exact
														activeClassName="active"
													>
														<span className="option-text">{t("settings.shifts.dayTypes")}</span>
													</NavLink>
												</li>
											</>
										)}
									</ul>
								</article>
							</Col>
						)}
						{showStaffing && (
							<Col sm={6}>
								<article className="card card-settings">
									<div className="card-header">
										<div className="card-icon-wrapper">
											<FiUsers className="card-icon" />
										</div>
										<h3 className="card-title">{t("settings.groups.title")}</h3>
									</div>
									<p>{t("settings.groups.description")}</p>
									<ul className="list-pages">
										{(isAdmin() || isSupervisorWithEditGroups) && (
											<li>
												<NavLink to="/groups" activeClassName="active">
													<span className="option-text">{t("settings.groups.groups")}</span>
												</NavLink>
											</li>
										)}

										<li>
											<NavLink
												to="/staffing-levels"
												exact
												activeClassName="active"
											>
												<span className="option-text">
													{t("settings.groups.staffingLevels")}
												</span>
											</NavLink>
										</li>
									</ul>
								</article>
							</Col>
						)}

						{isAdmin() && (
							<Col sm={6}>
								<article className="card card-settings">
									<div className="card-header">
										<div className="card-icon-wrapper">
											<FiSliders className="card-icon" />
										</div>
										<h3 className="card-title">{t("settings.rules.title")}</h3>
									</div>
									<p>{t("settings.rules.description")}</p>
									<ul className="list-pages">
										<li>
											<NavLink to="/rules" activeClassName="active">
												<span className="option-text">{t("settings.rules.rules")}</span>
											</NavLink>
										</li>
										<li>
											<NavLink to="/accounts" exact activeClassName="active">
												<span className="option-text">{t("settings.rules.accounts")}</span>
											</NavLink>
										</li>

										<li>
											<NavLink
												to="/transactions"
												exact
												activeClassName="active"
											>
												<span className="option-text">{t("settings.rules.transactions")}</span>
											</NavLink>
										</li>
									</ul>
								</article>
							</Col>
						)}

						{hasPowersWithExpensesSubscription && !isHaddockEnvironment() && (
							<Col sm={6}>
								<article className="card card-settings">
									<div className="card-header">
										<div className="card-icon-wrapper">
											<FiCreditCard className="card-icon" />
										</div>
										<h3 className="card-title">{t("settings.expenses.title")}</h3>
									</div>
									<p>{t("settings.expenses.description")}</p>
									<ul className="list-pages">
										<li>
											<NavLink to="/providers" exact activeClassName="active">
												<span className="option-text">{t("settings.expenses.providers")}</span>
											</NavLink>
										</li>
										<li>
											<NavLink
												to="/expense-types"
												exact
												activeClassName="active"
											>
												<span className="option-text">{t("settings.expenses.categories")}</span>
											</NavLink>
										</li>
										<li>
											<NavLink
												to="/payment-types"
												exact
												activeClassName="active"
											>
												<span className="option-text">{t("settings.expenses.paymentMethods")}</span>
											</NavLink>
										</li>
									</ul>
								</article>
							</Col>
						)}

						{isAdmin() && (
							<Col sm={6}>
								<article className="card card-settings">
									<div className="card-header">
										<div className="card-icon-wrapper">
											<FiLink className="card-icon" />
										</div>
										<h3 className="card-title">{t("settings.integrations.title")}</h3>
									</div>
									<p>{t("settings.integrations.description", { appName: integrationAppName })}</p>
									<ul className="list-pages">
										<li>
											<NavLink to="/integrations" exact activeClassName="active">
												<span className="option-text">{t("settings.integrations.link")}</span>
												<span className="badge-new">{t("common.new")}</span>
											</NavLink>
										</li>
									</ul>
								</article>
							</Col>
						)}

						</Row>
					</div>
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Settings));
